type ClinicGroupParam = { groupId: string };
type ClinicParam = { clinicId: string };
type ClinicBaseParam = ClinicGroupParam & ClinicParam;

export const STATIC_ROUTES = {
  CLINIC_TOP: "/:groupId/:clinicId",
};

export const ROUTES = {
  CLINIC_TOP: ({ groupId, clinicId }: ClinicBaseParam) =>
    STATIC_ROUTES.CLINIC_TOP.replace(":groupId", groupId).replace(":clinicId", clinicId),
  NOT_FOUND: "/404",
};
